import schoolMgmt from './schoolMgmt'
import classMgmt from './classMgmt'
import talMgmt from './talMgmt'
import menu from './menu'
import unit from './unit'
import common from './common'
export default {
  schoolMgmt,
  classMgmt,
  talMgmt,
  menu,
  unit,
  common,
  toolbox: {
    菜單: '選單',
    選擇: '選擇',
    回上一步: '回上一步',
    畫筆: '畫筆',
    圖形: '圖形',
    插入圖片: '道具箱',
    文字: '文字',
    橡皮擦: '橡皮擦',
    上一頁: '上一頁',
    新建一頁: '新建一頁',
    下一頁: '下一頁',
    缩放工具: '縮放工具',
    回到原始比例: '回到原始比例',
    IRS工具: '互動工具',
    推送圖片:'推送圖片',
    IRS即問即答: '即問即答',
    IRS填空: '文字題',
    IRS作品收集: '作品收集',
    IRS搶權: '搶權',
    挑人: '挑人',
    倒數計時: '倒數計時',
    雲桌遊: '雲桌遊',
    雲心智圖: '雲心智圖',
    重設為一般挑人模式:'重設為一般挑人模式',
    目前沒有動作可復原: '目前沒有動作可復原',
  },
  board: {
    hiTitle:'網頁版',
    前往:'前往',
    Gpt安裝提示標題:'安裝提示',
    GPT安裝提示字:'<p>您具備使用GPT工具之權限，建議可使Chrome或Edge的電腦版瀏覽器，<br>並前往下載安裝擴充套件，以支持GPT相關擴充功能，重新啟動登入即可使用!</p>',
    清空畫布提示字:'清空後無法復原，確定清空整個畫板? ',
    清空作品收集提示字:'清空後無法復原，確定清除目前已經繳交的作品?',
    網路斷線:'偵測到網路已經斷線，請檢查網路!',
    SignalR協議未正常連線:'部分通訊似乎斷線,建議重新整理！',
    閒置視窗文字:'閒置超過60分鐘，請點擊仍要使用，無動作將在1分鐘後自動登出',
    仍要使用:'仍要使用',
    文字工具:'文字便利貼工具',
    輸入文字:'輸入文字...',
    便利貼顏色:'便利貼顏色',
    確定:'確定',
    取消:'取消',
    雲桌遊: '雲桌遊',
    雲心智圖: '雲心智圖',
    選擇新增活動時之頁面內容:'請選擇新增活動的頁面內容',
    複製前一頁面:'複製前一頁內容',
    空白頁面:'空白新頁',
    螢幕大小基本需求說明:"不支援的裝置大小，為維持介面操作體驗，建議於電腦或平板電腦使用，且最低螢幕長寬解析度需求應至少達到 1024px*600px",
    歡迎使用HiTeachCC來進行互動: '歡迎使用HiTeach Web來進行互動',
    請選擇開始的動作: '請選擇開始的動作',
    開啟IES5所選教材:'開啟IES5所選教材',
    開啟PDF檔案: '使用PDF簡報',
    匯入Google教材: 'Google Drive匯入',
    直接使用畫板: '使用空白畫板',
    參閱使用範例PDF:'參閱使用說明PDF',
    您的使用權限:'您的權限',
    學生連線數:'連線人數',
    作品收集數:'作品收集數',
    aigptEXP:'AIGPT 到期時間',
    權限到期:'授權到期日',
    '無法使用，已達您的權限作品收集數上限':'很抱歉，作品任務數已達上限',
    '偵測到有請求加入，但加入教室人數已達您的權限人數上限':'很抱歉，教室連線人數已達上限',
    '權益說明':'',
    校園學校:'學校',
    校園學段:'學段',
    校園版授權:'校園版授權',
    了解更多:'了解更多',
    免費授權:'免費授權',
    專業版授權:'專業版授權',
    IRS單選題選項設置: '單選題選項設定',
    全屏幕: '全螢幕',
    重啟課堂: '結束重啟課堂',
    匯入xlsx問答: '匯入xlsx問答',
    結束登出: '離開系統',
    前往IES5: '前往 IES5',
    hiSection匯入: '匯入',
    hiSection匯出與名單: '匯出與名單',
    xlsxImport: {
      標題: '匯入 Excel 題目檔',
      檔案: '檔案：',
      選擇文件: '選擇 xlsx 文件',
      格式提示: '支持 .xlsx 和 .xls 格式',
      格式問題: '不清楚格式嗎？',
      下載範例: '下載範例檔案',
      取消: '取消',
      導入到畫板: '導入到畫板',
      導入中: '導入中',
      // 表格欄位
      欄位題號: '#',
      欄位分數: '分數',
      欄位答案: '答案',
      欄位題型: '題型',
      欄位題幹: '題幹',
      欄位選項1: '答案選項 1',
      欄位選項2: '答案選項 2',
      欄位選項3: '答案選項 3',
      欄位選項4: '答案選項 4',
      題型單選題: '單選題',
      題型文字題: '文字題',
      題型不支援: '不支援',
      分數格式: '({point}分)',
      // 訊息提示
      轉換提示: '題目匯入白板需轉換為圖片，請耐心等候...',
      成功解析有警告: '成功解析 {count} 題，{errors} 題有警告',
      成功解析: '成功解析 {count} 題',
      解析失敗: '解析失敗：{error}',
      沒有可匯入的題目: '沒有可匯入的題目',
      匯入已取消: '匯入已取消',
      轉換完成: '轉換完成：成功 {success} 題，失敗 {failed} 題',
      所有題目轉換失敗: '所有題目轉換失敗',
      成功導入: '成功導入 {count} 題到畫板',
      導入失敗: '導入失敗：{error}',
      沒有可導入的題目: '沒有可導入的題目',
      畫布未初始化: '畫布未初始化，請稍後再試',
      正在渲染: '正在渲染題目到畫板...',
      渲染已取消: '渲染已取消',
      正在上傳: '正在上傳圖片到雲端...',
      已處理: '已處理 {current}/{total} 題',
    },
    匯出PDF: '匯出PDF',
    匯出課堂記錄: '匯出課堂記錄',
    上傳課堂紀錄到Drive描述: '是否同意上傳課堂紀錄到 Google Drive？',
    上傳Drive中: '正在上傳課堂紀錄到 Google Drive…',
    上傳Drive成功: '課堂紀錄已成功上傳到 Google Drive',
    上傳Drive失敗: '上傳到 Google Drive 失敗',
    上傳Drive授權失敗改下載: 'Google Drive 授權失敗，改為下載課堂紀錄',
    插入PDF:'插入PDF',
    自訂學生名單:'新增IES5簡易名單',
    心智圖連結已推送給學生: '心智圖連結已推送給學生',
    心智圖連結推送失敗: '心智圖連結推送失敗',
    桌遊連結已推送給學生: '桌遊連結已推送給學生',
    桌遊連結推送失敗: '桌遊連結推送失敗',
    PDFInit:{
      開啟PDF檔案: '使用PDF簡報',
      從:'從',
      到:'到',
      加到目前課堂文件:'匯入成課堂教材',
      第:'第',
      頁之後:'頁之後',
      使用限制提示:'使用限制提示',
      目前課堂文件頁數:'目前課堂教材頁數',
      加入頁數:'加入頁數',
      最多:'最多',
      頁:'頁',
      總頁數:'總頁數',
      使用限制提示警告:'超出使用限制，無法使用! 請調整匯入頁數後方可使用',
      PDF載入錯誤:'PDF載入錯誤'
    },
    PDFInsert:{
      從:'從',
      到:'到',
      加到目前課堂文件:'加到目前課堂教材',
      第:'第',
      頁之後:'頁之後',
      使用限制提示:'使用限制提示',
      目前課堂文件頁數:'目前課堂教材頁數',
      加入頁數:'加入頁數',
      最多:'最多',
      頁:'頁',
      總頁數:'總頁數',
      使用限制提示警告:'超出使用限制，無法使用! 請調整匯入頁數後方可使用',
      PDF載入錯誤:'PDF載入錯誤'
    },
    轉檔匯出中請稍候: 'PDF 轉檔匯出中請稍候!',
    匯出與上傳課堂數據到IES5:'匯出與上傳課堂數據到IES5',
    作品收集: '作品收集',
    選擇貼回之頁面:'選擇貼回之頁面',
    貼到本頁:'貼到本頁',
    貼到新增的空白頁:'貼到新增的空白頁',
    暫無數據: '暫無數據',
    請按鈕開始接收搶權:'請按鈕開始接收搶權',
    繼續搶權:'繼續搶權',
    等待搶權:'等待搶權',
    qrcodePop: {
      '請掃碼QRcode 用瀏覽器參與課堂互動': '請同學掃碼, 開瀏覽器參與課堂互動',
      已複製到剪貼簿: '已複製到剪貼簿',
      請掃碼QRcode: '請掃碼QRcode',
      用瀏覽器參與課堂互動: '用瀏覽器參與課堂互動',
      或直接在瀏覽器上輸入下列網址: '或直接在瀏覽器上輸入下列網址',
      '提示：許多手機掃碼工具內建的瀏覽器功能受限，建議掃碼後另開系統瀏覽器': '提示：許多手機掃碼工具內建的瀏覽器功能受限，建議掃碼後另開系統瀏覽器',
      'allowVisitor': '免登入',
      'allowSitin': '旁聽'
    },
    物件轉換中請稍候: '物件轉換中請稍候',
    請先勾選: '請先勾選',
    一次勾選貼回最多6張: '一次勾選貼回最多6張',
    请登陆: '請登入',
    上传成功: '上傳成功',
    '上传失败！请查看PDF页数是否超过20页 是否符合标准': '注意！PDF頁數已超出頁數上限，僅會轉換限制內的頁數',
    'PDF頁數超出限制提示': '注意！PDF頁數已超出 {limit} 頁，僅會轉換前 {limit} 頁',
    正在制作画板: '正在產生頁面',
    制作画板制作成功: '頁面產生成功',
    上传格式有误: '上傳格式有誤',
    您上传的文件: '您上傳的檔案',
    '格式不正确, 请上传PDF格式': '格式不正確, 請上傳PDF格式',
    上传文件大小限制: '上傳檔案大小限制',
    '大小超过5M, 请上传不超过5M的文件': '檔案過大, 請上傳不超過5MB的檔案',
    正在制作中: '正在產生中',
    通讯连接已建立: '通訊連線已建立',
    '加入教室失败，请尝试重连!': '建立雲端教室失敗，請嘗試重整頁面!',
    '通讯连接失败，请尝试重连！': '通訊連線失敗，請嘗試重整頁面！',
    單選題已結束: '單選題已結束',
    文字題已結束: '文字題已結束',
    您的浏览器无法进入全屏模式: '您的瀏覽器無法進入全螢幕模式',
    '账号正在退出!': '正在退出！',
    本頁無Quiz活動: '本頁無互動活動',
    '正在努力加载，请稍等...': '處理中，請稍候...',
    '正在上传文件,请稍等...': '上傳檔案中,請稍候...',
    toolbox: {
      '此页已有题目，自動新增一页开启互动': '此頁已有活動，自動新增一頁開啟互動',
      畫面中已有心智圖視窗請先關閉或在新增頁面開啟: '畫面中已有心智圖視窗，請先關閉或在新增頁面開啟。',
      畫面中已有遊戲視窗請先關閉或在新增頁面開啟: '畫面中已有遊戲視窗，請先關閉或在新增頁面開啟。',
      目前已經是最後一頁: '目前已經是最後一頁',
      所選圖片過大:'所選圖片過大(應小於3MB)，請重新選擇！',
      畫筆: '畫筆',
      大小: '大小',
      顏色: '顏色',
      圖形: '圖形',
      邊框: '邊框',
      填充: '填充',
      比例: '比例',
      倒數: '倒數',
      計時: '計時',
      開始計時:'開始計時',
      暫停計時:'暫停計時',
      分:'分',
      秒:'秒',
      復位:'復位',
      重置:'歸零',
      記次:'記次',
      第:'第',
      條記錄:'條記錄',
      字體大小: '字體大小',
      IRS沒有學生提示訊息:'目前尚未有學生加入課堂, 請打開 QRcode 視窗讓學生掃描參與',
      通用畫筆:'通用畫筆',
      高光筆:'螢光筆',
      鐳射筆:'雷射筆',
      箭頭:'箭頭',
      直線:'直線',
      圓形:'圓形',
      橢圓:'橢圓',
      矩形:'矩形',
      三角形:'三角形',
      星形:'星形',
      刪除元素:'刪除元素',
      清空畫布:'清空畫布',
    },
    optionView: {
      統計翻牌自動結束: '統計翻牌後自動停止作答',
      匿名:'匿名',
      複製到剪貼簿: '複製到剪貼簿',
      餅圖: '圓餅圖',
      長條圖: '長條圖',
      翻牌: '翻牌',
      文字便利貼: '文字便利貼',
      文字雲:'文字雲',
      貼回舞台:'貼回舞台',
      停止作答: '停止作答',
      重新作答: '重新作答',
      單選題: '單選題',
      文字題: '文字題',
      '已全部複製到剪貼簿!': '已全部複製到剪貼簿!',
      '請先選擇要貼回的作品': '請先選擇要貼回的作品',
      '答案已重新開啟！請重新作答': '作答已重新開啟！請重新作答',
      設定答案成功:'設定答案成功',
      已移除答案:'已移除答案',
      設定無答案:'設定無答案',
      設定答案: '設定答案',
      無答案: '無答案',
      未作答: '未作答',
      重啟作答會清除所有已收到的數據: '重啟作答會清除所有已收到的資料',
      確定: '確定',
      取消: '取消',
      人:'人'
    },
    addImgBox:{
      檔案圖片:'插入圖片',
      選取本機檔案圖片:'選取圖片',
      剪貼簿:'剪貼簿',
      暫無數據:'暫無數據',
      取得複製到剪貼簿的資料:'取得剪貼簿的內容',
      轉換物件貼回:'貼回畫板',
      瀏覽器版本不支援:'您所使用的瀏覽器版本不支援此功能',
      瀏覽器不允許讀剪貼簿:'您所使用的瀏覽器不允許讀剪貼簿，請調整設定',
      素材庫:'素材庫',
      背景庫:'背景庫',
      發送文字:'推送文字',
      文字發送成功:'文字發送成功!',
      字串長度提示:'偵測到字串過長，僅顯示前500字！',
      確定:'確定',
      取消:'取消',
      截圖小工具:'截圖小工具',
      screenshotTool: {
        使用說明:'使用說明',
        步驟1:'請確認截圖小工具已安裝啟動',
        步驟2:'若已經安裝並啟動好截圖小工具，第一次請按下「開始連線」，本頁會自動連線到',
        步驟2b:'，瀏覽器若跳出需要核准訊息，請按下「同意」',
        步驟3:'可以先縮小瀏覽器，使用截圖小工具截取全螢幕或部分區域，這時再打開瀏覽器，截圖就會自動出現在畫板中',
        步驟4前:'請安裝便利的',
        步驟4連結文字:'擴充功能',
        步驟4後:'，截圖後自動喚醒瀏覽器的 HiTeach Web 標籤頁',
        開始連線:'開始連線',
        中斷連線:'中斷連線',
        未連線:'未連線到截圖小工具',
        連線中:'連線中...',
        已連線:'已連線',
        連線成功:'截圖小程式連線成功！',
        連線失敗:'連線失敗，請確認截圖小工具已啟動',
        已中斷連線:'已中斷連線',
        未連線提示:'截圖小工具目前未連線，如欲使用請手動連線！',
        截圖已貼上:'截圖已貼上畫板！',
        截圖已設為背景:'截圖已設定為背景！',
        上傳失敗:'上傳截圖失敗，請稍後再試',
        下載Mac版:'下載 Mac 版',
        下載Windows版:'下載 Windows 版'
      }
    },
    '暂无成员参与挑人。': '暫無成員參與挑人。',
    'Uploading': '上傳中',
    'ssoError': '您的帳號在其他設備登入，如果不是您的操作，請及時修改您的密碼。',
    objMenu:{
      刪除物件:'刪除',
      複製:'複製',
      移到最上層:'移到最上層',
      移到最下層:'移到最下層',
      將物件複製為圖片到剪貼簿:'複製物件圖片到剪貼簿',
      將物件複製為文字到剪貼簿:'複製文字到剪貼簿',
      已複製到剪貼簿: '已複製到剪貼簿!',
      瀏覽器版本不支援:'您所使用的瀏覽器版本不支援此功能',
      發送文字:'推送文字',
    },
    rightClickMenu:{
      從剪貼簿貼上:'從剪貼簿貼上'
    }
  },
  login: {
    formMsg: {
      error1: '取得Blob失敗',
      error2: '帳號或密碼錯誤',
      error3: '{state} 授權失敗',
      error4: '快速登入失敗',
      error5: '請使用HiTA 5掃描',
      error6: '創建教室失敗'
    },
    currentLang: '中文繁體',
    loginBox: {
      title: 'HiTeach Web',
      intro: '無硬體要求，無任何安裝HiTeach的設備均可與一體機電子白板互動教學',
      loginWord: '醍摩豆帳號登入',
      StudentEntrance: '學生/參與者 加入教室',
      headertitle: 'HiTeach Web',
      authLoginTitle: '或下列方式登入',
      loginId: 'Email / 手機帳號 / 用戶編號',
      password: '密碼',
      regist: '免費註冊',
      forgotPW: '忘記密碼',
      qrcode:{
        text1: '可使用',
        text2: 'HiTA 5',
        text3: '掃描登入',
        text4: '是否要掃碼登入?',
      }
    },
    footer: {
      create: '創建醍摩豆帳號'
    }
  },
  formConfigP: {
    input: '請輸入',
    select: '請選擇',
    country: '國家',
    province: '省份',
    city: '城市',
    school: '學校'
  },
  index: {
    login: '登入',
    register: '註冊',
    chooseRole: '選擇身份',
    exit: '退出',
    authSchool: '授權學校',
    currentRole: '當前身份',
    loginSuc: '登入成功'
  },
  //學情分析
  saindex: {
    index: '首頁',
    grade: '成績分析',
    droppoint: '落點分析',
    examination: '試題分析',
    knowledge: '知識點掌握'
  },
  sasidebar: {
    class: '選擇關注年級',
    classmsg: '請選擇年級',
    term: '選擇關注學年期',
    term: '請選擇學年期',
    compare: '選擇數據對比'
  },
  copyright: `Copyright © ${new Date().getFullYear()} 網奕資訊科技 版權所有`,
  error: {
    required: '不能為空',
    format: {
      default: '格式錯誤'
    }
  },
  remind: {
    title: '提醒',
    content: '當前瀏覽器不是Chrome瀏覽器，為了您更好的體檢，建議使用Chrome瀏覽器體驗！',
    toDownload: '去下載'
  },
  loadingMsg:{
    text1: '<b>初始化</b>......<br/><span class="text-primary">請等待...</span>',
    text2: '<b>登入中</b>......<br/><span class="text-primary">請等待...</span>'
  },
  report: {
    title: '課堂數據總表',
    activityName: '班級/課程',
    hostName: '授課者',
    meterialName: '教材',
    dateTime: '日期時間',
    attendCount: '出席人數',
    attendRate: '出席率',
    collateTaskCount: '發起任務數',
    collateCount: '收到作品數',
    pushCount: '推送資源數',
    totalInteractPoint: '總互動分',
    interactionCount: '互動題數',
    clientInteractionCount: '學生互動總數',
    clientInteractionAverge: '平均互動數',
    quizID: '題序',
    pageOrderStr: '頁次',
    score: '配分',
    correctAnswer: '正解',
    correctRateStr: '得分率',
    seatID: '座號',
    name: '姓名',
    attendState: '出席',
    attendState1: '已出席',
    attendState0: '未出席',
    taskCompleteCount: '作品數',
    interactScore: '互動分',
    answerList: '學生作答',
  },
  memberlist:{
    自由加入:'臨時名單',
    個人課程:'個人名單',
    雲端學校課程:'學校名單',
    Google課程名單:'Google\nClassroom 名單',
    Google帳號已被使用:'目前你選的 Google 帳號已被其他醍摩豆帳號使用，請改用其他 Google 帳號再試一次',
    Google授權失敗:'Google 授權失敗，發生不明錯誤，請稍後再試。',
    Google授權已失效:'Google 授權已失效，請重新授權後再試一次。',
    Google增量授權成功:'Google 增量權益獲取成功！',
    Google授權未完整:'系統發現你的 Google 授權部分為未勾選，請再試一次才可使用完整的功能',
    googleDriveDownloading:'正在從 Google Drive 下載檔案…',
    googleDriveExporting:'正在從 Google Drive 匯出簡報…',
    googleDriveImportFailed:'Google Drive 匯入失敗：{msg}',
    googleDriveExportForbidden:'此檔案無法存取，請確認您是否有存取權限。',
    googleDriveExportForbiddenDomainPolicy:'此檔案無法存取，可能是所屬組織封鎖了第三方應用程式的存取。',
    請啟用Google服務描述:'請啟用 Google 服務的權限，以體驗 HiTeach Web 完整的功能',
    啟用Google服務按鈕:'點我啟用 Google 服務',
    學生人數:'學生人數',
    選課班:'選課班',
    編制班:'編制班',
    簡易班:'簡易班',
    全部:'全部',
    載入中:'載入中...',
    請先選擇學校:'請先選擇學校',
    暫無課程資料:'暫無課程資料',
    重新整理:'重新整理',
    請選擇學生名單:'請選擇上課名單',
    創建自訂學生名單:'新建立預存的學生名單',
    新增簡易名單:'按此新建個人名單',
    使用IES5課程名單:'IES5開課<br>跳轉所選名單',
    點選左側指定可加入的學生名單:'點選左側列表選擇IES5的名單',
    點選Hi進行編輯:'如需新增名單，請按下一步進入系統後從Hi選單操作',
    下一步:'下一步',
    上一步:'上一步',
    編輯學生:'編輯學生',
    新增學生:'新增學生',
    姓名:'姓名',
    座號:'座號',
    座號重複:'座號重複',
    座號不可為空或輸入無法辨認的值:'座號不可為空或輸入無法辨認的值',
    姓名不可為空:'姓名不可為空',
    確定:'確定',
    取消:'取消',
    修改名單名稱:'修改名單名稱',
    表單名稱不可為空:'表單名稱不可為空',
    確定刪除後這個名單將無法復原:'確定刪除後這個名單將無法復原!',
    刪除:'刪除',
    自訂學生名單:'新增IES5簡易名單',
    新增說明:'目前僅簡易提供於HiTeach課程類別下(HiTeach-)新增名單功能，如需使用其他課程類別，編輯或刪除等進階管理請於IES5設定，新增後請重新整理方可使用',
    創建名單:'新建名單',
    暫無數據:'暫無數據',
    新建的學生名單:'新建的學生名單...',
    輸入名單資料:'輸入名單資料...(姓名,座號)',
    自動編號提示字:'無法辨識座號規則，系統自動編號',
    預覽:'預覽轉換',
    儲存預覽表格:'儲存名單',
    名單範例模板: `輸入名單小技巧<br><br>名單的格式為：
    姓名, 座號 <br>(座號可省略，如有填寫則須每列都填寫)<br><br>
    限制<br>
    姓名：字數長度50以內<br>
    座號：不能重複數字，應小於1000
     <br><br>
    範例 <br>
    王大明, 1<br>
    張小凡, 2<br>
    陳士軒, 3<br>`,
    複製範例:'複製範例',
    自訂名單:'我的名單',
    帶有重複座號:'帶有重複座號',
    座號範圍提示字:'座號應設定於1-999',
    名單人數上限提示字:'名單人數超過上限100人，請刪減人數',
    新增單筆名單人數達上限提示字:'名單人數達上限100人，無法新加',
    自訂名單已達上限提示字:'預存名單已達3個上限',
    範例名單:`王大明, 1\n張小凡, 2\n陳士軒, 3\n`,
    載入學校班級資料中:'載入學校班級資料中...',
    目前沒有可用的學校班級資料:'目前沒有可用的學校班級資料',
    學段:'學段',
    無可用學段:'無可用學段',
    請先選擇學段:'請先選擇學段',
    班級類型:'班級類型',
    編制班:'編制班',
    選課班:'選課班',
    年級:'年級',
    年級後綴:'級',
    無可用年級:'無可用年級',
    請先選擇年級:'請先選擇年級',
    班級:'班級',
    無符合的班級:'無符合的班級',
    請先選擇班級類型:'請先選擇班級類型',
    人:'人',
    位學生:'位學生',
    已選擇:'已選擇',
    預覽名單:'預覽名單',
    學生名單:'學生名單',
    關閉:'關閉',
    建立方式:'建立方式：',
    手動建立:'手動建立',
    從預設學校名單複製:'從IES5預設學校名單複製',
    儲存名單:'儲存名單',
    名單建立成功:'名單建立成功',
    建立名單失敗:'建立名單失敗',
    名單名稱重複:'名單名稱已存在，請使用其他名稱'
  },
  gptBox:{
    Gpt工具:'GPT工具箱',
    管理指令:'管理指令',
    常用指令:'常用指令',
    可輸入一段100字以內的指令:'可輸入一段100字以內的指令...',
    總結大意:'總結大意',
    整理同義字:'整理同義字',
    等候提示字:'請等候GPT回答完這個問題再做下一個!',
    等候關閉互動窗提示字:'請等候GPT回答完這個問題再關閉!',
    預設:'預設',
    繼續:'繼續',
    當前語系指令:'請用繁體中文，',
    確定:'確定',
    取消:'取消',
    確定刪除後這個分類將無法復原:'確定刪除後這個分類將無法復原!',
    刪除:'刪除',
    新增分類:"新增分類",
    已達最大上限10個分類:"已達最大上限10個分類",
    暫無數據:"暫無指令資料",
    emptyReply:"GPT目前仍在生成中，暫無回應數據，請按右上角「查詢生成結果」，或再試一次！",
    queryResult:"查詢生成結果",
    aiDisclaimer:"AI 可能產生錯誤資訊，請使用者自行查核",
  },
  pwa: {
    networkOffline: '目前處於離線模式',
    networkOnline: '已恢復連線',
    retry: '重試連線',
    retrying: '重試中',
    stillOffline: '網路仍未恢復，請稍後再試',
    backOnline: '網路已恢復',
    minutes: '分鐘',
    seconds: '秒',
    updateTitle: '有新版本可用',
    updateMessage: '應用程式有新版本，請更新以獲得最新功能與修復。',
    updateLater: '之後再說',
    updateNow: '立即更新',
    installMessage: '將 HiTeach Web 加到您的裝置主畫面，方便快速開啟。',
    installBtn: '加到主畫面',
    installDismiss: '忽略',
  }
}
